var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24",
    width: "24px",
    height: "24px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface207449403"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 19.988281 3.984375 C 19.726562 3.992188 19.476562 4.101562 19.292969 4.292969 L 12 11.585938 L 4.707031 4.292969 C 4.519531 4.097656 4.261719 3.992188 3.988281 3.988281 C 3.582031 3.992188 3.21875 4.238281 3.0625 4.613281 C 2.910156 4.992188 3 5.421875 3.292969 5.707031 L 11.292969 13.707031 C 11.683594 14.097656 12.316406 14.097656 12.707031 13.707031 L 20.707031 5.707031 C 21.003906 5.421875 21.09375 4.980469 20.9375 4.601562 C 20.777344 4.222656 20.402344 3.976562 19.988281 3.984375 Z M 19.988281 9.984375 C 19.726562 9.992188 19.476562 10.101562 19.292969 10.292969 L 12 17.585938 L 4.707031 10.292969 C 4.519531 10.097656 4.261719 9.992188 3.988281 9.988281 C 3.582031 9.992188 3.21875 10.238281 3.0625 10.613281 C 2.910156 10.992188 3 11.421875 3.292969 11.707031 L 11.292969 19.707031 C 11.683594 20.097656 12.316406 20.097656 12.707031 19.707031 L 20.707031 11.707031 C 21.003906 11.421875 21.09375 10.980469 20.9375 10.601562 C 20.777344 10.222656 20.402344 9.976562 19.988281 9.984375 Z M 19.988281 9.984375 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/down-arrow.41672c22.svg";
export { ForwardRef as ReactComponent };